import React, { useEffect } from 'react';
import { initMetaPixelWithPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { FaqSection } from '../components/FaqSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function TaxRescuePage() {
  useEffect(() => {
    initMetaPixelWithPageView();
  }, []);
  return <main className="w-full min-h-screen bg-midnight-950 font-body" data-id="element-257">
      <HeroSection data-id="element-258" />
      <ProblemSection data-id="element-259" />
      <SolutionSection data-id="element-260" />
      <AudienceSection data-id="element-261" />
      <ProcessSection data-id="element-262" />
      <FaqSection data-id="element-263" />
      <OfferSection data-id="element-264" />
      <Footer data-id="element-265" />
    </main>;
}